module.exports = __webpack_public_path__ + "img/nick.1f59f905.jpg";